import React, {FC, useEffect} from 'react';
import {FilterQueryType, FilterType} from "../../../types/page-layout-types";
import './AppSelect.css';


interface AppSelectProps {
    list: FilterType[];
    defaultOption: FilterType;
    handleFilterChange: (value: string,list: FilterType[]) => void;
    filterQuery: FilterQueryType;
}

const AppSelect:FC <AppSelectProps> = ({list = [], defaultOption, handleFilterChange,filterQuery}) => {

    const [selectedItem, setSelectedItem] = React.useState<FilterType>(defaultOption);
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        if(Object.keys(filterQuery).length < 1 && selectedItem.value !== "") {
            setSelectedItem(defaultOption);
        }
    }, [filterQuery, defaultOption, selectedItem.value]);

    const handleOption = (newValue: FilterType) =>{
        setOpen(false);
        setSelectedItem(newValue);
        handleFilterChange(newValue.value,list)
    }

    return (
        <div className="input-group">
            <input className="form-control form-select" type="text" value={selectedItem.name} onClick={()=>{setOpen(true)}} readOnly/>
            <div className={`select-container__modal ${open ?'border':''}`}>
                {open && (<ul>
                    {
                      Object.values(list).map((item, index) => (
                          <li key={index} onClick={() => handleOption(item)}>{index === 0 ? 'Не выбрано' : item?.name}</li>
                      ))
                    }
                </ul>)
                }
            </div>
            {
              open && (<div className="clickaway" onClick={()=>setOpen(false)} />)
            }
        </div>
    );
};

export default AppSelect;